import { graphql } from "react-relay";

export const fragments = {
  eventMoved: graphql`
    fragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {
      originalStartTime {
        millis
      }
      newStartTime {
        millis
      }
      moveReasons
      addedRooms
      removedRooms
      event {
        title
        startTime {
          millis
        }
        endTime {
          millis
        }
        eventKey {
          externalEventId
        }
      }
    }
  `,
  rooms: graphql`
    fragment TailoredDefragSummaryEventMoved_rooms on RoomList {
      list {
        roomId
        name
      }
    }
  `,
};
